import React from 'react';

import LandingPage from './pages/LandingPage';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import AppLayout from './components/layout/AppLayout';
import DashboardPage from './pages/DashboardPage';
import UploadPage from './pages/UploadPage';
import DataReviewPage from './pages/DataReviewPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AskGabMicPage from './pages/AskGabMicPage';
import SettingsPage from './pages/SettingsPage';
import PricingPage from './pages/PricingPage';
import BillingCallbackPage from './pages/BillingCallbackPage';

const App: React.FC = () => {
  const path = window.location.pathname;

  if (path === '/') return <LandingPage />;
  if (path === '/signin') return <SignInPage />;
  if (path === '/signup') return <SignUpPage />;

  return (
    <AppLayout>
      {renderAppPage(path)}
    </AppLayout>
  );
};

const renderAppPage = (path: string) => {
  switch (path) {
    case '/dashboard':
      return <DashboardPage />;
    case '/upload':
      return <UploadPage />;
    case '/review':
      return <DataReviewPage />;
    case '/analytics':
      return <AnalyticsPage />;
    case '/ask':
      return <AskGabMicPage />;
    case '/pricing':
      return <PricingPage />;
    case '/billing/callback':
      return <BillingCallbackPage />;
    case '/settings':
      return <SettingsPage />;
    default:
      return <DashboardPage />;
  }
};

export default App;
